import React, { useState } from "react";
import { Button, Dialog, DialogContent, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { WS_TYPES } from "../wsProtocol";

// floating "ask the teacher" button — the question lands in the teacher inbox
const AskQuestionButton = ({ send, disabled }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [sentAt, setSentAt] = useState(null);

  const submit = (event) => {
    event.preventDefault();
    if (!text.trim()) return;
    send({ t: WS_TYPES.SQ_ASK, text: text.trim() });
    setText("");
    setSentAt(Date.now());
    setTimeout(() => setOpen(false), 1200);
  };

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        disabled={disabled}
        onClick={() => { setSentAt(null); setOpen(true); }}
        sx={{ position: "fixed", bottom: 24, insetInlineStart: 24, zIndex: 30, borderRadius: "100vh", fontWeight: 800, boxShadow: "0 6px 24px rgba(0,0,0,0.3)" }}
      >
        💬 {t("wb_ask_teacher")}
      </Button>

      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="xs" PaperProps={{ sx: { borderRadius: "18px" } }}>
        <DialogContent sx={{ padding: "24px" }}>
          <Typography fontWeight={800} mb={2}>💬 {t("wb_ask_teacher")}</Typography>
          {sentAt ? (
            <Typography color="success.main" fontWeight={700}>✓ {t("wb_question_sent")}</Typography>
          ) : (
            <form onSubmit={submit}>
              <TextField
                fullWidth
                multiline
                minRows={2}
                autoFocus
                value={text}
                onChange={(event) => setText(event.target.value)}
                placeholder={t("wb_question_placeholder")}
                inputProps={{ maxLength: 300 }}
              />
              <Button type="submit" fullWidth variant="contained" disabled={!text.trim()} sx={{ borderRadius: "100vh", marginTop: 2, fontWeight: 700 }}>
                {t("wb_send_question")}
              </Button>
            </form>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AskQuestionButton;
